export const ACCESS_TOKEN = 'accessToken';
export const ACCESS_TOKEN_KEYCLOAK = 'accessTokenKeyCloak';
export const NUM_TICKET_ON_PAGE = 6;

export const REFRESH_TOKEN = 'refreshToken';
export const CDN_URL = 'https://cdnelearning.hanhtrangso.com.vn/';

export const BASE_URL = process.env.REACT_APP_BASE_ENDPOINT_URL;
export const API_BASE_URL_REMOTE = process.env.REACT_APP_API_BASE_URL_REMOTE;
export const GOOGLE_AUTH_URL = `${BASE_URL}/oauth2/authorize/google?redirect_uri=${process.env.REACT_APP_AUTH_REDIRECT_URI}`;
export const FACEBOOK_AUTH_URL = `${BASE_URL}/oauth2/authorize/facebook?redirect_uri=${process.env.REACT_APP_AUTH_REDIRECT_URI}`;

export const API_GET_QA_TICKET_BY_USER_ID = `${process.env.REACT_APP_BASE_ENDPOINT_URL}/qna-tickets/creater?studentId=`;
export const API_POST_MESSAGE = `${process.env.REACT_APP_BASE_ENDPOINT_URL}/qna-detail`;
export const API_UPLOAD_FILE = `${process.env.REACT_APP_BASE_ENDPOINT_URL}/media/upload`;
export const API_GET_QA_MESSAGE = `${BASE_URL}/qna-detail/ticket/`;
export const API_GET_QA_TICKET_DETAIL = `${BASE_URL}/qna-tickets/`;

export const API_POST_QA_RATE = `${BASE_URL}/qna-rate`;

export const API_FILTER_BY_STATUS = `${BASE_URL}/qna-tickets/filter/status/`;
export const API_FILTER_BY_STATUS_RATE = `${BASE_URL}/qna-tickets/filter/status-rate/`;
export const API_SEARCH_QNA_TICKET_BY_NAME = `${BASE_URL}/qna-tickets/search/`;

export const API_REGISTER_USER = `${API_BASE_URL_REMOTE}/identity-service/register`;
export const API_GET_USER_INF = `${process.env.REACT_APP_BASE_ENDPOINT_URL}/user/getInf`;

export const API_GET_QNA_TICKET_ADMIN = `${process.env.REACT_APP_BASE_ENDPOINT_URL}/qna-tickets`;
export const API_GET_QNA_UPDATE_TICKET = `${process.env.REACT_APP_BASE_ENDPOINT_URL}/qna-tickets/`;
export const API_GET_QNA_TICKET_BY_SUBJECT_ID = `${process.env.REACT_APP_BASE_ENDPOINT_URL}/qna-tickets/filter/subject/`;

export const API_GET_TICKET_PACKAGE = `${BASE_URL}/ticket-package/page/`;
export const API_CREAT_TICKET_PACKAGE = `${BASE_URL}/ticket-package`;
export const API_FILTER_PACKAGE = `${BASE_URL}/ticket-package/filter`;
export const API_SEARCH_PACKAGE = `${BASE_URL}/ticket-package/search/`;

export const API_GET_FEED_BACK = '/feedback'

export const API_GET_TOKEN = 'http://10.32.7.71:31999/realms/hts2.0/protocol/openid-connect/token';
export const API_REFRESH_TOKEN = `${API_BASE_URL_REMOTE}/identity-service/refresh-token`;
export const API_VERIFY_TOKEN = `${API_BASE_URL_REMOTE}/user/verify-token`;
